import { useMutation } from "@/api/utils/useQuery"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import {
  CreateUserFromJuniferResponse,
  OtpResponse,
} from "@/api/backofficeRest/generated/model"
import { MutationResult } from "@/api/utils/types"
import { HasuraMutations } from "@/api/hasura/mutations"
import {
  DeleteUserMutation,
  UpdateUserMutation,
  UpdateUserPasswordMutation,
} from "@/api/hasura/generated/graphql"
import {
  ICreateUserFromJuniferPayload,
  IGenerateOtpPayload,
  IUserUpdatePayload,
  IUserUpdatePasswordPayload,
} from "./UserMutator.types"

export interface IUserMutator {
  createFromJunifer(): MutationResult<
    ICreateUserFromJuniferPayload,
    CreateUserFromJuniferResponse
  >
  generateOtp(): MutationResult<IGenerateOtpPayload, OtpResponse>
  update(): MutationResult<IUserUpdatePayload, UpdateUserMutation>
  updatePassword(): MutationResult<
    IUserUpdatePasswordPayload,
    UpdateUserPasswordMutation
  >
  delete(): MutationResult<number, DeleteUserMutation>
}

export class UserMutatorClass implements IUserMutator {
  createFromJunifer(): MutationResult<
    ICreateUserFromJuniferPayload,
    CreateUserFromJuniferResponse
  > {
    return useMutation({
      ...BackofficeRestMutations.user.createFromJunifer(),
      serializerFn: (data: ICreateUserFromJuniferPayload) => ({
        junifer_account_number: data.accountNumber,
        skip_email: data.skipEmail,
        email: data.email,
      }),
      invalidateCache: false,
    })
  }

  generateOtp(): MutationResult<IGenerateOtpPayload, OtpResponse> {
    return useMutation({
      ...BackofficeRestMutations.admin.generateOtp(),
      serializerFn: (data) => data,
      invalidateCache: false,
    })
  }

  update(): MutationResult<IUserUpdatePayload, UpdateUserMutation> {
    return useMutation({
      ...HasuraMutations.user.update(),
      serializerFn: (data) => {
        return {
          userId: data.userId,
          email: data.email,
          lockedAt: data.lockedAt?.toISOString(),
        }
      },
      invalidateCache: false,
    })
  }

  updatePassword(): MutationResult<
    IUserUpdatePasswordPayload,
    UpdateUserPasswordMutation
  > {
    return useMutation({
      ...HasuraMutations.user.updatePassword(),
      serializerFn: (data) => data,
      invalidateCache: false,
    })
  }

  delete(): MutationResult<number, DeleteUserMutation> {
    return useMutation({
      ...HasuraMutations.user.delete(),
      serializerFn: (userId) => {
        return { userId }
      },
      invalidateCache: false,
    })
  }
}

export const UserMutator = new UserMutatorClass()
